import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'

import { useDelayedAction, useGetCurrentLoanApplicationID } from '@krea/common/hooks'
import { closeModal } from '@krea/common/store/modal/actions'
import { CURRENT_LOAN_APPLICATION_STORE_KEY } from '@krea/common/store/queryClient'
import { useGetOneFieldRequest } from '@krea/common/store/field-requests/hooks/queries'
import { useIsFieldRequestSubmitting } from '@krea/common/store/field-requests/hooks/mutations'

import { Button } from '../index'
import { DialogActions, DialogContent, DialogTitle } from '../dialog'
import GetFieldRequestForm from '../field-request/GetFieldRequestForm'

const FieldRequestModal = ({ fieldRequestID }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const queryClient = useQueryClient()
	const loanApplicationID = useGetCurrentLoanApplicationID()

	const isFieldRequestSubmitting = useIsFieldRequestSubmitting(fieldRequestID)
	const delayAction = useDelayedAction(isFieldRequestSubmitting)

	const { data: fieldRequest = {} } = useGetOneFieldRequest(fieldRequestID)

	const saveAndCloseFunction = () => {
		dispatch(closeModal())
		queryClient.invalidateQueries({ queryKey: [CURRENT_LOAN_APPLICATION_STORE_KEY, loanApplicationID] })
	}

	const saveAndClose = () => {
		delayAction(saveAndCloseFunction)
	}

	return (
		<>
			{fieldRequest && <DialogTitle title={fieldRequest.displayName} />}
			<DialogContent withLabel>{fieldRequest && <GetFieldRequestForm fieldRequestID={fieldRequestID} />}</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={saveAndClose} id="modal-submit-button">
					{t('commons.save')}
				</Button>
			</DialogActions>
		</>
	)
}

export default FieldRequestModal
